import {  useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"


// class ScrollToTop extends Component<RouteComponentProps> {
    
//     componentDidUpdate(prevProps: RouteComponentProps) {
//         if (this.props.location !== prevProps.location) {
//             window.scrollTo(0, 0)
//         }
//     }

//     render() {
//         return this.props.children
//     }
// }

// export default withRouter(ScrollToTop)
export default function ScrollToTop ({children}:{children:any}){
    const location=useLocation()
    let latest=useRef('')
    useEffect(()=>{
        if (location.pathname && location.pathname !== latest.current){
            latest.current=location.pathname
            window.scrollTo(0, 0)
        }
    },[location.pathname])
    return (
        <>
         {children}
        </>
    )
}